import { FormattedMessage } from 'react-intl';

import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import type { DocumentProps } from '@/features/administration/contract/types';

export const Document = ({ title, url, documentType }: DocumentProps) => {
    const debugConfig = createDebugConfig();

    const handleClick = () => {
        trackCustomEvent(
            'charging_contract_documents',
            {
                trigger: 'click',
                flow_name: 'documents',
                element_name: documentType,
                element_state: 'active',
            },
            debugConfig
        );
    };

    return (
        <div className='panel panel-default padding-15 display-flex align-items-center'>
            <span className='uikit-icon icon-document text-size-h4 margin-right-5' />
            {title}
            {url ? (
                <a
                    href={url}
                    className='btn btn-primary btn-link margin-left-auto gap-0'
                    target='_blank'
                    rel='noreferrer noopener'
                    onClick={handleClick}
                >
                    <span className='uikit-icon icon-new-window' aria-hidden='true' />
                    <FormattedMessage id='general.button.seeDetails' />
                </a>
            ) : null}
        </div>
    );
};
